module.exports = __webpack_public_path__ + "static/img/5-5.06598a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-5/5-5.jpg
// module id = 747
// module chunks = 1